<template>
  <div :class="`benefit-notification-box-base ${color} ${variant ? variant : ''}`">
    <img class="icon" :src="require(`@/assets/${iconPath}`)">
    <div class="text-container">
      <div class="title">
        {{ title }}
        <slot v-if="!title" name="title" />
      </div>
      <div
        :class="['description', { 'clickable': isWebPayment }]"
        @click="handleDescriptionClick"
      >
        {{ description }}
        <span v-if="isWebPayment" class="chevron">{{ '>' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BenefitNotificationBoxBase',
  props: {
    iconPath: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    title: {
      type: String,
    },
    color: {
      type: String,
      required: false,
      validator: val => !val || ['green', 'blue', 'red'].includes(val),
    },
    variant: {
      type: String,
      required: false,
      validator: val => !val || ['web-payment', 'on-web'].includes(val),
    },
    linkText: {
      type: String,
      required: false,
    },
  },
  computed: {
    isWebPayment() {
      return this.variant === 'web-payment';
    },
  },
  methods: {
    handleDescriptionClick() {
      if (this.isWebPayment) {
        this.$emit('description-click');
      }
    },
    handleLinkClick() {
      this.$emit('link-click');
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.benefit-notification-box-base {
  display: flex;
  padding: 20px 15px;
  border-radius: 8px;
  width: 100%;
  background-color: $riseup_beige;
  font-size: 14px;
  line-height: 1.36;

  &.green {
    background-color: $riseup_light_green;
  }

  &.blue {
    background-color: $riseup_light_blue;
  }

  &.red {
    background-color: $riseup_danger_light_red;
  }

  &.web-payment {
    .description {
      &.clickable {
        color: $riseup_blue;
        text-decoration: none;
        cursor: pointer;
        font-weight: bold;

        .chevron {
          font-size: 14px;
        }
      }
    }
  }

  &.on-web {
    .description {
      &.clickable {
        color: $riseup_blue;
        text-decoration: underline;
        cursor: pointer;
        font-weight: bold;
        display: inline-block;
        .chevron {
          color: $riseup_blue;
          font-size: 14px;
          display: inline;
        }
      }
    }
  }

  .icon {
    width: 30px;
    height: 30px;
    margin-left: 15px;
  }

  .text-container {
    .title {
      margin-bottom: 5px;
      font-weight: bold;
    }
  }

  .web-only-link {
    color: $riseup_blue;
    text-decoration: underline;
    font-weight: bold;
    cursor: pointer;
    margin-top: 8px;
    display: inline-block;
  }
}

</style>
